/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_HeadingInputs */

const tr_mesafeli_s6_heading = /** @type {(inputs: Mesafeli_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Abonelik Süresi, Ödeme Şekli ve Yenileme`)
};

const en_mesafeli_s6_heading = /** @type {(inputs: Mesafeli_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Subscription Term, Payment Method and Renewal`)
};

const de_mesafeli_s6_heading = /** @type {(inputs: Mesafeli_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Laufzeit, Zahlungsweise und Verlängerung`)
};

const ru_mesafeli_s6_heading = /** @type {(inputs: Mesafeli_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Срок подписки, способ оплаты и продление`)
};

/**
* | output |
* | --- |
* | "6. Subscription Term, Payment Method and Renewal" |
*
* @param {Mesafeli_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_heading = /** @type {((inputs?: Mesafeli_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_heading(inputs)
	if (locale === "de") return de_mesafeli_s6_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s6_heading(inputs)
	return tr_mesafeli_s6_heading(inputs)
});